import React, {useEffect, useRef} from 'react';
import {Player, TextComponent} from '@galacean/effects';
import '@galacean/effects-plugin-spine';
import {useModalManager} from '@basicComponents/sequential-modal/ModalManagerProvider';

const source = '/assets/checkin/checkin.json';

export default function CheckSuccess(props: {value: number}) {
  const {value = ''} = props;
  const player = useRef<Player>();
  const {hideModal} = useModalManager();
  const playerContainer = useRef<HTMLDivElement>(null);
  useEffect(() => {
    player.current = new Player({
      container: playerContainer.current,
      interactive: true,
    });
    player.current.loadScene(source).then(res => {
      const item = res.getItemByName('金额num');
      const text = item?.getComponent(TextComponent);
      text?.setText('₹' + value);
      // // 添加按钮监听
      const btn = res.getItemByName('button-中');
      btn?.on('click', () => {
        console.log('click');
        hideModal(CheckSuccess.MODAL_ID);
      });
    });
    return () => {
      player.current?.dispose();
      player.current = void 0;
    };
  }, [hideModal, value]);
  return (
    <div ref={playerContainer} className="relative w-screen h-screen"></div>
  );
}

CheckSuccess.MODAL_ID = 'check-success';
